import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Field, propTypes, reduxForm } from 'redux-form'
import { connect } from 'react-redux'
import compose from 'recompose/compose'
import CardActions from '@material-ui/core/CardActions'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import CircularProgress from '@material-ui/core/CircularProgress'
import { withStyles, createStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import { translate } from 'ra-core'
import { envPreffix } from '../../utils'
import { Login } from 'react-admin'
import httpClient from '../../utils/httpClient'
import { push } from 'react-router-redux'

const styles = () => createStyles({
  login: {
    main: {
      backgroundImage: 'url(/login_bg.jpg) !important',
    },
    card: {
      padding: '5px 0 15px 0',
      '& > div' : {
        display : 'none'
      }
    },
  },
  form: {
    padding: '0 1em 1em 1em',
    button: {
      height: '3em',
    },
  },
  input: {
    marginTop: '1em',
  },
  button: {
    width: '100%',
  },
  button2: {
    width: '100%',
    fontSize: 10
  },
  title : {
    color : '#646567',
    textAlign : 'center',
    fontSize : 23
  },
  text : {
    color : '#646567',
    textAlign : 'center',
    fontSize : 10
  },
  logo : {
    '& img' : {
      width : '100%',
      height : '100%',
    },
    padding: 20,
    boxSizing: 'border-box',
    height: 130
  }
})

// see http://redux-form.com/6.4.3/examples/material-ui/
const renderInput = ({
    meta: { touched, error } = { touched: false, error: '' }, // eslint-disable-line react/prop-types
    input: { ...inputProps }, // eslint-disable-line react/prop-types
    ...props
}) => (
    <TextField
        error={!!(touched && error)}
        helperText={touched && error}
        {...inputProps}
        {...props}
        fullWidth
    />
)
const envTitle = envPreffix()

class ChangePassword extends Component {
  state = {
    message: ""
  }
  handleSubmit = (values = {}) => {
    httpClient(`${process.env.API_URL}/api/v1/usuarios/forget-password`, {
      method: 'POST',
      body: JSON.stringify(values)
    })
    .then(res => {
      res.json && this.setState({ message: res.json.message || ''})
    })
    .catch(err => {
      err.body && this.setState({ message: err.body.message || ''})
    })
  }
  render () {
    const { classes, isLoading, handleSubmit, translate } = this.props
    const { message } = this.state
    return (
      <form onSubmit={handleSubmit(values => this.handleSubmit(values))} setFilt>
          <div className={classes.form}>
              <div>
                  <div className={classes.logo} >
                      <img src="/logo_coordinador.svg" alt={"logo coordinador eléctrico"} />
                  </div>
                  <Typography className={classes.title} variant={'title'}>
                      Recuperar Contraseña {envTitle ? <strong style={{color: 'red'}}><br/>{envTitle}</strong> : ''}
                  </Typography>
                  <Typography className={classes.text}>
                      Para recuperar tu contraseña se necesita que ingreses el nombre de usuario y el email
                  </Typography>
              </div>
              <div className={classes.input}>
                  <Field
                      id="username"
                      name="username"
                      component={renderInput}
                      label={translate('ra.auth.username')}
                      disabled={isLoading}
                  />
              </div>
              <div className={classes.input}>
                  <Field
                      id="email"
                      name="email"
                      component={renderInput}
                      label={translate('ra.auth.email')}
                      disabled={isLoading}
                  />
              </div>
          </div>
          {message && (<strong style={{color: 'red', textAlign: 'center'}}>{message}</strong>)}
          <CardActions>
              <Button
                  variant="raised"
                  type="submit"
                  color="primary"
                  disabled={isLoading}
                  className={classes.button}
              >
                  {isLoading && <CircularProgress size={25} thickness={2} />}
                  {translate('ra.auth.button_forget_password')}
              </Button>
          </CardActions>
          <CardActions>
            <Button
              variant="raised"
              color="secondary"
              size="small"
              className={classes.button2}
              onClick={() => this.props.push('/login')}
            >
            Ir al Login
            </Button>
        </CardActions>
      </form>
    )
  }
}
ChangePassword.propTypes = {
    ...propTypes,
    classes: PropTypes.object,
    redirectTo: PropTypes.string,
}

const LoginPage = (props) => (
    <Login loginForm={<ChangePassword {...props}/>} {...props} />
);

const mapStateToProps = state => ({ isLoading: state.admin.loading > 0 })

const enhance = compose(
    withStyles(styles),
    translate,
    connect(mapStateToProps, { push }),
    reduxForm({
        form: 'redux-form',
        validate: (values, props) => {
            const errors = {}
            const { translate } = props
            if (!values.username)
                errors.username = translate('ra.validation.required')
            if (!values.email)
                errors.email = translate('ra.validation.required')
            return errors
        },
    })
)

export default enhance(LoginPage)
